module.exports = __webpack_public_path__ + "static/media/pay-cash.77583403.svg";